import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '@app/shared-module/common-service.service';
import { DoctorService } from '@app/services/doctor.service';
import { GlobalResponse, Doctor, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  // isLoggedIn: boolean = false;
  // phoneToggle = false;
  // clinicToggle = true;
  @Input() isLoggedIn: boolean;
  @Input() navLarge: boolean;
  userList: User[] = [];
  doctor_selected: any;
  doctor: User = {} as User;
  action: string;
  enableCheckup = false;

  // constructor(
  //   private commonService: CommonService,
  //   private toastr: ToastrService,
  //   private doctorService: DoctorService,
  //   private router: Router,
  //   private activatedRoute: ActivatedRoute
  // ) { }

  ngOnInit() {
    // this.router
    //   .events.pipe(
    //     filter(event => event instanceof NavigationEnd),
    //     map(() => {
    //       let child = this.activatedRoute.firstChild;
    //       if (child && child.firstChild) {
    //         while (child.firstChild) {
    //           child = child.firstChild;
    //         }
    //       }
    //       // console.log('enableExtraHeader');
    //       // console.log(child.snapshot);
    //       // console.log(child.snapshot.data.enableExtraHeader);
    //       if (child.snapshot.data.enableExtraHeader) {
    //         return child.snapshot.data.enableExtraHeader;
    //       }
    //       return false;
    //     })
    //   ).subscribe((res: boolean) => {
    //     this.enableCheckup = res;
    //   });
    // this.doctor = JSON.parse(localStorage.getItem('internallogin'));
    // if (this.commonService.doctorValue) {
    //   this.isLoggedIn = true;
    //   this.phoneToggle = this.commonService.doctorValue.settings.phone_consultation_available;
    //   this.clinicToggle = this.commonService.doctorValue.settings.inclinic_available;
    // }
    // if (this.router.url.indexOf('home') > -1 || this.router.url.indexOf('activate') > -1 || this.router.url.indexOf('internallogin') > -1
    //   || this.router.url.indexOf('doctor-registration') > -1 || this.router.url.indexOf('recover') > -1) {
    //   this.isLoggedIn = false;
    // }
    // this.fetchStaff();
  }

  // toggleDoctor() {
  //   const settingsPayload = {
  //     inclinic_available: this.clinicToggle,
  //     phone_consultation_available: this.phoneToggle
  //   };
  //   this.doctorService.updateDoctorSettings(settingsPayload).subscribe((res: GlobalResponse) => {
  //     if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
  //       this.toastr.success(Constants.LABEL_SUCCESS, 'Settings Updated');
  //       localStorage.removeItem('internallogin');
  //       localStorage.setItem('internallogin', JSON.stringify(res.result));
  //       this.commonService.setCurrentUserValue(res.result);
  //     }
  //   });
  // }

  // fetchStaff() {
  //   this.doctorService.fetchDoctorList().subscribe((res: GlobalResponse) => {
  //     if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
  //       // console.log(res.result);
  //       this.doctorList = res.result.doctor;
  //       this.doctorList.unshift(this.doctor);
  //       this.doctor_selected = this.doctor;
  //       if (this.doctorList && this.doctorList.length > 0) {
  //         for (const item of this.doctorList) {
  //           item.name = item.first_name + ' ' + item.last_name;
  //         }
  //       }
  //       this.action = this.doctor.name;
  //     }
  //   });
  // }

  // doctorChanged(item: Doctor) {
  //   if (item) {
  //     this.action = item.name;
  //     this.commonService.checkupDoctorSubject.next(item);
  //   }
  // }
}
